<!-- PAGOS -->
<div class="bg-black pb-24 sm:pb-0">
	<div *ngIf="false" class="bg-white h-full">
		<div class="pago bg-white py-12 px-6 sm:px-0 sm:grid sm:grid-flow-col auto-cols-auto sm:gap-20">
			<div class="w-full">
				<div class="w-full sm:ml-12 flex justify-center">
					<p class="basic-text tracking-tight text-center">{{ 'footer.pagoProtegido' | translate }}</p>
				</div>

				<div class="w-full flex justify-center pago-img sm:pl-20"><img src="assets/images/pago.jpg" alt="Pago protegido" class="h-28" /></div>
			</div>
			<div class="sm:mr-20">
				<div class="pt-10 sm:pt-0 pb-2 flex justify-center">
					<p class="basic-text tracking-tight text-center">{{ 'footer.pasarela' | translate }}:</p>
				</div>
				<div class="w-full flex justify-center"><img src="assets/images/powered-by-stripe.png" alt="Pasarela de pago" class="w-96 mt-4 max-w-full" /></div>
			</div>
		</div>
	</div>
	<div class="bg-black text-white w-full h-auto relative px-6 pt-2 md:pt-10 pb-10 lg:pb-20 lg:pl-60">
		<div class="w-full md:w-max md:max-w-screen-2xl sm:mx-auto md:mx-0 py-10 md:py-0 flex flex-col md:flex-row gap-4 md:gap-60 justify-center md:justify-between items-center lg:items-start">
			<!-- <div class="w-full md:w-max">
                <app-second-newsletter></app-second-newsletter>
            </div> -->
			<div class="w-full md:w-auto flex-1 flex flex-col justify-between md:justify-start gap-2 pt-4">
				<p class="text-xl text-white font-bold">Links</p>
				<hr class="w-12 h-0.5 bg-gris-claro" />
				<ul class="mt-4 gap-y-2 flex flex-col">
					<li class="text-sm w-full md:w-max cursor-pointer">
						<a (click)="open('politics')" class="hover:underline focus:underline focus:outline-none"> {{ 'footer.politicas' | translate }} </a>
					</li>
					<li class="text-sm w-full md:w-max cursor-pointer">
						<a class="hover:underline focus:underline focus:outline-none" (click)="open('returs-politics')" > {{ 'footer.refund' | translate }} </a>
					</li>
					<li class="text-sm w-full md:w-max cursor-pointer">
						<a class="hover:underline focus:underline focus:outline-none" (click)="open('shipping-policy')" > {{ 'footer.shipping' | translate }} </a>
					</li>
					<li class="text-sm w-full md:w-max cursor-pointer">
						<a (click)="open('terms')" class="hover:underline focus:underline focus:outline-none"> {{ 'footer.terminos' | translate }} </a>
					</li>
					<li class="text-sm w-full md:w-max cursor-pointer">
						<a (click)="open('subscription-policy')" class="hover:underline focus:underline focus:outline-none"> {{ 'footer.suscribirse' | translate }} </a>
					</li>
					<li class="text-sm w-full md:w-max cursor-pointer">
						<a routerLink="/{{this.id_store_current }}/my-subscriptions" class="hover:underline focus:underline focus:outline-none"> My Subscriptions </a>
					</li>
				</ul>
				<!-- <ul> -->
				<!-- <li class="w-full md:w-max cursor-pointer"><a (click)="redirect('about-us')" routerLink="/{{this.id_store_current}}/about-us" class="cursor-pointer hover:underline focus:underline focus:outline-none">About Us </a></li>
                    <li class="w-full md:w-max cursor-pointer">Blog</li>
                    <li class="w-full md:w-max cursor-pointer">Purchases</li>
                    <li class="w-full md:w-max cursor-pointer">Credits </li>
                    <li class="w-full md:w-max cursor-pointer">Preferences </li> -->
				<!-- <li class="w-full md:w-max"><a routerLink="/home/terms" class="hover:underline focus:underline focus:outline-none"> {{'header.contacto' | translate}} </a></li> -->
				<!-- </ul> -->
			</div>
			<div class="w-full md:w-auto flex-1 flex flex-col justify-between md:justify-start gap-2 text-sm relative pt-4">
				<p class="text-xl text-white font-bold">Get Connected!</p>
				<hr class="w-12 h-0.5 bg-gris-claro" />
				<ul class="mt-4 gap-y-2 flex flex-col">
					<li class="text-base w-full md:w-max">Join Our Coffee-Golf Community</li>
					<li class="text-base w-full md:w-max">Swing By For Daily Doses Of Coffee Goodness!</li>
					<li class="text-base w-full md:w-max">
						<!-- <a href="/{{this.id_store_current }}/points-of-sale" class="hover:underline focus:underline focus:outline-none">Find Our Locations</a> -->
						<a href="/{{this.id_store_current }}/find-us" class="hover:underline focus:underline focus:outline-none">Find Our Locations</a>
					</li>
				</ul>
				<div class="w-full relative">
					<div class="absolute left-0 flex gap-x-4 z-10 mt-6">
						<a target="_blank" href="https://www.instagram.com/rednumberscoffee/" class="text-center justify-center rounded-full mx-auto">
							<img src="/assets/icons/instagram-footer.svg" alt="Instagram" class="w-8 h-auto mx-auto" />
						</a>
						<a target="_blank" href="https://www.tiktok.com/@rednumberscoffee" class="text-center justify-center rounded-full mx-auto">
							<img src="/assets/icons/tiktok-footer.svg" alt="TikTok" class="w-8 h-auto mx-auto" />
						</a>
						<a target="_blank" href="https://www.facebook.com/profile.php?id=100093050805962" class="text-center justify-center rounded-full mx-auto">
							<img src="/assets/icons/facebook-footer.svg" alt="Facebook" class="w-8 h-auto mx-auto" />
						</a>
					</div>
				</div>
			</div>
			<!-- <div class="w-full md:w-auto flex-1 text-sm relative pt-4">
				<hr class="absolute top-0 left-0 w-12 h-0.5 bg-gris-claro" />
				<h6 class="leading-4">
					Red Numbers Company, LLC<br />
					4120 West 104th Street<br />
					Suite 13<br />
					Hialeah, FL 33018
				</h6> -->
			<!-- <a class="pt-4 block" href="mailto:help@elevendeco.com" target="_blank"> help@elevendeco.com</a> -->
			<!-- </div> -->
			<!-- <div *ngIf="false" class="w-full md:w-auto flex-1 relative pt-4">
				<hr class="absolute top-0 left-0 w-12 h-0.5 bg-gris-claro" />
				<ul>
					<li class="my-2 pb-2 flex justify-between border-b border-dashed border-gris-claro">
						<div>Mon - Fri</div>
						<div>8:00 am - 9:00 pm</div>
					</li>
					<li class="my-2 pb-2 flex justify-between border-b border-dashed border-gris-claro">
						<div>Saturday</div>
						<div>9:00 am - 8:00 pm</div>
					</li>
					<li class="my-2 pb-2 flex justify-between border-b border-dashed border-gris-claro">
						<div>Sunday</div>
						<div>9:00 am - 6:00 pm</div>
					</li>
				</ul>
			</div> -->
		</div>
	</div>
	<div class="footer bg-black lg:px-8 lg:py-2 w-auto lg:flex lg:flex-row z-10 sm:z-20 relative items-center">
		<div class="flex flex-col md:flex-row z-10 max-w-screen-xl mx-auto w-full justify-between px-20 lg:px-10 items-center">
			<div class="lg:self-center">
				<p class="footer-text pb-0 lg:pb-4">© {{ 'footer.copyright' | translate }} {{ year }}. Red Numbers Coffee</p>
			</div>

			<!-- <div class="lg:self-center flex gap-x-4 justify-center">
				<a routerLink="/home/terms" class="footer-text py-4 lg:py-0 hover:text-principal-hover focus:text-principal-hover focus:outline-none"> {{ 'footer.terminos' | translate }} </a>
				<a routerLink="/home/politics" class="footer-text py-4 lg:py-0 hover:text-principal-hover focus:text-principal-hover focus:outline-none"> {{ 'footer.politicas' | translate }} </a>
			</div> -->

			<div class="flex flex-row gap-x-2 justify-center lg:justify-end">
				<a href="" class="footer-text py-4 lg:py-0 hover:text-principal-hover focus:text-principal-hover focus:outline-none">
					<img src="/assets/icons/payment-card1.svg" loading="lazy" alt="Visa" class="w-8 h-auto mx-auto" />
				</a>
				<a href="" class="footer-text py-4 lg:py-0 hover:text-principal-hover focus:text-principal-hover focus:outline-none">
					<img src="/assets/icons/payment-card2.svg" loading="lazy" alt="Paypal" class="w-8 h-auto mx-auto" />
				</a>
				<a href="" class="footer-text py-4 lg:py-0 hover:text-principal-hover focus:text-principal-hover focus:outline-none">
					<img src="/assets/icons/payment-card3.svg" loading="lazy" alt="Mastercard" class="w-8 h-auto mx-auto" />
				</a>
				<a href="" class="footer-text py-4 lg:py-0 hover:text-principal-hover focus:text-principal-hover focus:outline-none">
					<img src="/assets/icons/payment-card4.svg" loading="lazy" alt="Amex" class="w-8 h-auto mx-auto" />
				</a>
			</div>
		</div>
	</div>
</div>
